import { render, staticRenderFns } from "./BaseList.vue?vue&type=template&id=72b577d4"
import script from "./BaseList.vue?vue&type=script&lang=ts"
export * from "./BaseList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports